import type { TFunction } from 'i18next';

import { GridRecord } from '../../components/Grid/GridDataTypes';
import { DefaultApi } from '../autogenerated/pokApiClient';
import { eodImportLogForGrid } from '../../../pok/components/EOD/EodImportLogSearch';
import { TKeys } from '../../hooks/useTranslation';

export interface EodImportLogContextInterface {
  getAllByPortion: (
    t: TFunction<'fvzLng', 'fvzLng'>,
    tk: TKeys<'fvzLng'>,
    companyId: string,
    refresh: boolean,
    setRefresh: (refresh: boolean) => void,
    pageSize: number,
    pageNumber: number,
    orderBy?: string,
    orderDirection?: string,
    filterText?: string,
    filterColumns?: string,
  ) => Promise<GridRecord[]>;
  getAllCount: (
    companyId: string,
    filterText?: string,
    filterColumns?: string,
  ) => Promise<number>;
  getToDoByPortion: (
    t: TFunction<'fvzLng', 'fvzLng'>,
    tk: TKeys<'fvzLng'>,
    companyId: string,
    refresh: boolean,
    setRefresh: (refresh: boolean) => void,
    pageSize: number,
    pageNumber: number,
    orderBy?: string,
    orderDirection?: string,
    filterText?: string,
    filterColumns?: string,
  ) => Promise<GridRecord[]>;
  getToDoCount: (
    companyId: string,
    filterText?: string,
    filterColumns?: string,
  ) => Promise<number>;
  reimportToPOK: (documentId: number) => Promise<void>;
  joinWithFVZ: (eodId: number) => Promise<void>;
}

export const EodImportLogContext = (api: DefaultApi) => {
  return {
    getAllByPortion: async (
      t: TFunction<'fvzLng', 'fvzLng'>,
      tk: TKeys<'fvzLng'>,
      companyId: string,
      refresh: boolean,
      setRefresh: (refresh: boolean) => void,
      pageSize: number,
      pageNumber: number,
      orderBy?: string,
      orderDirection?: string,
      filterText?: string,
      filterColumns?: string,
    ) => {
      const data = await api.eodImportLogControllerGetAllByPortion(
        companyId,
        JSON.parse(filterColumns || '{}'),
        pageSize,
        pageNumber,
        orderBy || '',
        orderDirection || '',
        filterText || '',
      );
      return data.map(item =>
        eodImportLogForGrid(t, tk, item, refresh, setRefresh),
      );
    },
    getAllCount: (
      companyId: string,
      filterText?: string,
      filterColumns?: string,
    ) =>
      api.eodImportLogControllerGetAllCount(
        companyId,
        JSON.parse(filterColumns || '{}'),
        filterText || '',
      ),
    getToDoByPortion: async (
      t: TFunction<'fvzLng', 'fvzLng'>,
      tk: TKeys<'fvzLng'>,
      companyId: string,
      refresh: boolean,
      setRefresh: (refresh: boolean) => void,
      pageSize: number,
      pageNumber: number,
      orderBy?: string,
      orderDirection?: string,
      filterText?: string,
      filterColumns?: string,
    ) => {
      const data = await api.eodImportLogControllerGetToDoByPortion(
        companyId,
        JSON.parse(filterColumns || '{}'),
        pageSize,
        pageNumber,
        orderBy || '',
        orderDirection || '',
        filterText || '',
      );
      return data.map(item =>
        eodImportLogForGrid(t, tk, item, refresh, setRefresh),
      );
    },
    getToDoCount: (
      companyId: string,
      filterText?: string,
      filterColumns?: string,
    ) =>
      api.eodImportLogControllerGetToDoCount(
        companyId,
        JSON.parse(filterColumns || '{}'),
        filterText || '',
      ),
    reimportToPOK: (documentId: number) =>
      api.eodDocumentControllerReimportToPOK(documentId),
    joinWithFVZ: (eodId: number) => api.eodLogControllerJoinWithFVZ(eodId),
  };
};
